import React from 'react'
import styles from 'components/shared/image-input.module.scss'
import cn from 'classnames'

export default function ImageInput(props) {
    const { src, alt, handleImg } = props
    return (
        <div className={cn(styles.imageInputComp, props.contextStyles)}>
            {src && (
                <div className={cn(styles.imageContainer)}>
                    <img src={src} alt={alt} className={styles.image} />
                </div>
            )}

            <div className="team-input-group">
                <label className={styles.header} htmlFor="team_team_image">
                    {props.label}
                </label>

                <input
                    id="team_team_image"
                    name={props.name}
                    type="file"
                    accept={props.accept}
                    onChange={handleImg}
                />
            </div>
        </div>
    )
}
